// Global currency for the RIVL platform — Nigerian Naira.
// Centralised so we can switch to dynamic per-region later.
export const APP_CURRENCY = 'NGN';
export const APP_CURRENCY_SYMBOL = '\u20A6'; // ₦

export function formatCurrency(amount, currency = APP_CURRENCY) {
  const n = Number(amount || 0);
  try {
    return new Intl.NumberFormat('en-NG', {
      style: 'currency',
      currency: currency || APP_CURRENCY,
      maximumFractionDigits: 0,
    }).format(n);
  } catch {
    return `${APP_CURRENCY_SYMBOL}${n.toLocaleString()}`;
  }
}

export function formatFee(fee, currency) {
  if (!fee || Number(fee) === 0) return 'Free';
  return formatCurrency(fee, currency);
}
